import { useState } from "react"

const faqs = [
  {
    q: "如何訂購這款限定香氛？",
    a: "請先完成銀行轉帳，再填寫訂購人資料、匯款確認與 7-ELEVEN 店到店資訊。我們核對款項無誤後，會依訂單順序安排出貨。",
  },
  {
    q: "付款方式與金額怎麼計算？",
    a: "目前只提供銀行轉帳。售價 NT$ 1,680 已含 7-ELEVEN 店到店運費，匯款金額請依訂購組數計算，無須另加運費。",
  },
  {
    q: "收件方式是什麼？",
    a: "全館採 7-ELEVEN 店到店寄送。請填寫正確的門市名稱與地址，以利順利寄達。",
  },
  {
    q: "訂單成立後，多久會出貨？",
    a: "訂單送出後會寄送 Email，確認我們已收到您的訂單資訊。待核對匯款無誤，將依付款順序安排出貨。",
  },
  {
    q: "限定香氛售完後會補貨嗎？",
    a: "微光 Inner Light 為江美琪限定香氛，售完即不再製作，敬請把握收藏機會。",
  },
  {
    q: "還有其他問題可以怎麼聯絡？",
    a: "歡迎來信 info@mrearmusic.com，或致電 02-77094888。",
  },
]

function Faq() {
  const [open, setOpen] = useState(0)

  return (
    <section id="faq" data-nav="dark" className="bg-[#efe8dc] px-8 py-20 md:px-10 md:py-24">
      <div className="mx-auto max-w-2xl">
        <p className="font-display text-sm tracking-[0.32em] text-slate-400">FAQ</p>
        <h2 className="mt-3 font-serif-tc text-3xl tracking-[0.18em] text-slate-800">常見問題</h2>
        <div className="mt-10 divide-y divide-slate-200 border-y border-slate-200">
          {faqs.map((item, index) => {
            const isOpen = open === index
            return (
              <div key={item.q}>
                <button
                  type="button"
                  className="flex w-full items-center justify-between py-5 text-left"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                >
                  <span className="pr-6 text-[14px] tracking-[0.06em] text-slate-700">{item.q}</span>
                  <span className="text-slate-400">{isOpen ? "−" : "+"}</span>
                </button>
                {isOpen ? (
                  <p className="pb-5 text-[13px] leading-7 text-slate-500">{item.a}</p>
                ) : null}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Faq
